import {useEffect, useRef} from 'react'

import {copilotLocalStorage} from '../utils/copilot-local-storage'
// eslint-disable-next-line no-restricted-imports
import {useChatState} from '../utils/CopilotChatContext'
import {useChatManager} from '../utils/CopilotChatManagerContext'
import {getSelectedThread} from '../utils/get-selected-thread'

export function useChat(inputRef?: React.RefObject<HTMLTextAreaElement | null>) {
  const state = useChatState()
  const manager = useChatManager()
  const {currentTopic, messages, selectedThreadID} = state
  const thread = getSelectedThread(state)
  const chatTextAreaRef = useRef<HTMLTextAreaElement>(null)
  const textAreaRef = inputRef || chatTextAreaRef

  useEffect(() => {
    if (thread && messages.length > 0) {
      manager.showTopicPicker(false)
    }
  }, [thread, messages.length, manager])

  useEffect(() => {
    const topicID = currentTopic ? String(currentTopic.id) : null
    if (selectedThreadID && topicID) {
      copilotLocalStorage.setSelectedTopic(selectedThreadID, topicID)
    }
  }, [selectedThreadID, currentTopic])

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      textAreaRef.current?.focus()
    }, 1)
    return () => {
      window.clearTimeout(timeout)
    }
  }, [textAreaRef])

  useEffect(() => {
    const generateSuggestions = () => {
      const suggestionContext = state.context?.[0] ?? state.currentRepository
      if (!suggestionContext) return

      manager.generateSuggestions(suggestionContext)
    }

    void generateSuggestions()

    return () => {
      manager.clearSuggestions()
    }
  }, [manager, state.context, state.currentTopic, state.currentRepository, state.selectedThreadID])

  return {textAreaRef}
}
